/**
 * Single source of truth for username ↔ pseudo-email identity.
 * Used by LoginPromptModal, Auth page, and AuthContext.
 */

const POLISH_MAP: Record<string, string> = {
  ą: "a", ć: "c", ę: "e", ł: "l", ń: "n",
  ó: "o", ś: "s", ź: "z", ż: "z",
  Ą: "a", Ć: "c", Ę: "e", Ł: "l", Ń: "n",
  Ó: "o", Ś: "s", Ź: "z", Ż: "z",
};

/** Replace Polish diacritics with ASCII equivalents (always lowercase output for letters). */
export const transliteratePolish = (str: string): string =>
  str.replace(/[ąćęłńóśźżĄĆĘŁŃÓŚŹŻ]/g, (ch) => POLISH_MAP[ch] || ch);

/** Normalize a username for comparison / email generation: transliterate + lowercase. */
export const normalizeUsername = (username: string): string =>
  transliteratePolish(username.toLowerCase());

/** Generate a deterministic pseudo-email from a display username. */
export const generateEmailFromUsername = (username: string): string =>
  `${normalizeUsername(username)}@biozadania.local`;
